import {createTheme, Theme} from "@mui/material";
import {ws, wsHex} from "styles/tokens";
import type {ColorScheme} from "services/ColorSchemeService";

// MUI derives hover and contrast shades from the palette, so it needs literal colours;
// surfaces and text that MUI only paints go through the CSS variables.
const DARK = {
  accent: "#2fb3d3",
  accentDeep: "#0385a8",
  fg: "#eef3f4",
  muted: "#a4afb3",
  card: "#172125",
  bg: "#0f1517",
  line: "rgba(255,255,255,0.12)"
};

export function getMuiTheme(scheme: ColorScheme): Theme {
  const dark = scheme === "dark";
  return createTheme({
    palette: {
      mode: scheme,
      primary: {
        main: dark ? DARK.accent : wsHex.accent,
        dark: dark ? DARK.accentDeep : wsHex.accentDeep,
        contrastText: "#ffffff"
      },
      secondary: {main: dark ? DARK.fg : wsHex.fg},
      error: {main: wsHex.danger},
      success: {main: wsHex.success},
      warning: {main: wsHex.warning},
      text: {primary: dark ? DARK.fg : wsHex.fg, secondary: dark ? DARK.muted : wsHex.muted},
      background: {default: dark ? DARK.bg : wsHex.wash, paper: dark ? DARK.card : wsHex.card},
      divider: dark ? DARK.line : wsHex.line
    },
    shape: {borderRadius: 10},
    zIndex: {modal: 90001, snackbar: 90002, tooltip: 90002},
    typography: {
      fontFamily: ws.fontBody,
      h1: {fontFamily: ws.fontDisplay, fontWeight: 400, letterSpacing: "-0.02em"},
      h2: {fontFamily: ws.fontDisplay, fontWeight: 400, letterSpacing: "-0.02em"},
      h3: {fontFamily: ws.fontDisplay, fontWeight: 400, letterSpacing: "-0.02em"},
      h4: {fontFamily: ws.fontDisplay, fontWeight: 500},
      h5: {fontFamily: ws.fontDisplay, fontWeight: 500},
      h6: {fontFamily: ws.fontDisplay, fontWeight: 500},
      button: {fontWeight: 600, textTransform: "none"}
    },
    components: {
      MuiButton: {
        defaultProps: {disableElevation: true},
        styleOverrides: {root: {borderRadius: 999}}
      },
      MuiChip: {styleOverrides: {root: {borderRadius: 999, fontWeight: 600}}},
      MuiPaper: {
        styleOverrides: {root: {backgroundImage: "none"}, rounded: {borderRadius: 16}}
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {borderRadius: 10, backgroundColor: ws.field},
          notchedOutline: {borderColor: "transparent"}
        }
      },
      MuiTooltip: {
        styleOverrides: {tooltip: {backgroundColor: ws.fg, color: ws.bg, borderRadius: 6}}
      }
    }
  });
}
